import React, { useState } from 'react';
import { X, Printer, Send, CheckCircle } from 'lucide-react';
import { sendSalaryEmail } from '../../services/adminService';
import { showSuccess, showError } from '../../utils/sweetAlert';
import './SalarySlipModal.css';

const SalarySlipModal = ({ employee, payroll, onClose, isAfterPayment }) => {
    const [sending, setSending] = useState(false);
    const [isSent, setIsSent] = useState(payroll.isSent || false);

    const handlePrint = () => {
        // Open the dedicated print route in a new window/tab
        const url = `/admin/print-slip/${employee._id}/${payroll.month}/${payroll.year}`;
        window.open(url, '_blank');
    };

    const handleSendEmail = async () => {
        setSending(true);
        try {
            await sendSalaryEmail({
                employeeId: employee._id,
                month: payroll.month,
                year: payroll.year
            });
            setIsSent(true);
            showSuccess('Email Sent', 'Salary slip sent to employee successfully.');
        } catch (error) {
            showError('Email Failed', 'Failed to send salary slip email.');
        } finally {
            setSending(false);
        }
    };

    const handlePrintAndSend = async () => {
        handlePrint();
        await handleSendEmail();
    };

    return (
        <div className="salary-modal-overlay">
            <div className="salary-modal-content">
                <div className="salary-modal-header">
                    <h2>Salary Slip</h2>
                    <div className="header-actions" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {isSent && (
                            <span style={{ display: 'flex', alignItems: 'center', color: '#10b981', fontSize: '0.9rem', fontWeight: '500', marginRight: '5px' }}>
                                <CheckCircle size={16} style={{marginRight: 5}}/> Already sent on email
                            </span>
                        )}
                        <button 
                            onClick={() => {
                                window.location.href = `/admin/employees/${employee._id}/pay-salary?month=${payroll.month}&year=${payroll.year}&edit=true`;
                            }} 
                            className="btn-secondary" 
                            style={{ display: 'flex', alignItems: 'center', backgroundColor: '#e2e8f0', color: '#475569', border: 'none', cursor: 'pointer' }}
                        >
                            ✏️ Edit Details
                        </button>
                        <button onClick={handleSendEmail} className="btn-secondary" disabled={sending} style={{ display: 'flex', alignItems: 'center' }}>
                            <Send size={16} style={{marginRight: 5}}/> {sending ? 'Sending...' : (isSent ? 'Resend to Employee' : 'Send to Employee')}
                        </button>
                        {!isSent && (
                            <button onClick={handlePrintAndSend} className="btn-primary" disabled={sending} style={{ display: 'flex', alignItems: 'center' }}>
                                <Printer size={16} style={{marginRight: 5}}/> {sending ? 'Sending...' : 'Print & Send'}
                            </button>
                        )}
                        <button onClick={handlePrint} className="btn-secondary" title="Print Only" disabled={sending} style={{ display: 'flex', alignItems: 'center' }}>
                            <Printer size={16} style={{marginRight: 5}}/> Print Only
                        </button>
                        <button onClick={onClose} className="close-btn" disabled={sending}>
                            <X size={24} />
                        </button>
                    </div>
                </div>

                <div className="salary-slip-preview">
                    <iframe
                        title="Salary Slip Preview"
                        src={`/admin/print-slip/${employee._id}/${payroll.month}/${payroll.year}?preview=true`}
                        className="preview-iframe"
                    />
                </div>
            </div>
        </div>
    );
};

export default SalarySlipModal;
